import Vue from 'vue'

// (Core) Components
import './components/core'

// (Sustaine Custom) Components
import './components/sustaine'

// Plugins
import './plugins'

// Mixins
import '@/mixins'

// Application Imports
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

// Configuration
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'

// SCSS / CSS
import '@/assets/scss/app.scss'

// Service Worker
import '@/registerServiceWorker'

import vuetify from './plugins/vuetify'

const app = new Vue({
  data: {
    loading: false,
    env: process.env.NODE_ENV
  },

  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

/*
 * Routing navigation guard, before each route, evaluate authentication
 * needs and redirect accordingly
 *   to: Route: the target Route Object being navigated to.
 * from: Route: the current route being navigated away from.
 * next: Function: this function must be called to resolve the hook.
 */

router.beforeEach((to, from, next) => {
  // document title
  document.title = 'Sustaine: ' + to.meta.title
  // Start the animation of the loading spinner
  if (to.name) {
    app.loading = true
  }
  // page authorization check
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth)
  const userIsAuthorized = app.$store.getters.getUserToken != null
  if (requiresAuth && !userIsAuthorized) {
    next('/login')
  } else {
    next()
  }
})

/*
 * Routing navigation guard, bafter  each route ...
 *   to: Route: the target Route Object being navigated to.
 * from: Route: the current route being navigated away from.
 */
router.afterEach((to, from) => {
  // Complete the animation of the loading spinner
  app.loading = false
})
